import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpInterceptorFn,
  HttpHandlerFn,
} from '@angular/common/http';
import { EMPTY } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { CognitoService } from '../services/cognito.service';

export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService<unknown>);
  const cognitoService = inject(CognitoService);
  const router = inject(Router);

  if (
    authService.token?.toString() &&
    authService.tokenExpired(authService.token?.toString())
  ) {
    cognitoService.signOut();
    router.navigate(['/login']);
    return EMPTY;
  }

  const headers = req.headers.set(
    'Authorization',
    authService.token ? `Bearer ${authService.token.toString()}` : 'null',
  );
  const clonnedRequest = req.clone({
    headers,
  });
  return next(clonnedRequest);
};
